import { combineReducers } from 'redux';
import addCarEligibility from './addCarEligibility';
import vinCheck from './vinCheck';
import registrationInfo from './registrationInfo';
import uploadDocuments from './uploadDocuments';
import addCarProcess from './addCarProcess';
import signedToken from './signedToken';
import userSignedToken from './userSignedToken';
import billingAddress from './billingAddress';

export default combineReducers({
  vinCheck,
  addCarEligibility,
  registrationInfo,
  uploadDocuments,
  addCarProcess,
  signedToken,
  userSignedToken,
  billingAddress,
});
